// Standardized animation configurations for consistent user experience
export const animations = {
  // Standard fade in from bottom animation for section headers
  fadeInUp: {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8 }
  },

  // Standard fade in from left animation
  fadeInLeft: {
    initial: { opacity: 0, x: -30 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.8 }
  },

  // Standard fade in from right animation
  fadeInRight: {
    initial: { opacity: 0, x: 30 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.8 }
  },

  // Standard fade in from bottom with delay
  fadeInUpDelayed: {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay: 0.2 }
  },

  // Standard fade in from bottom with longer delay
  fadeInUpLongDelay: {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay: 0.4 }
  },

  // Standard container variants for staggered animations
  containerVariants: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  },

  // Standard item variants for staggered animations
  itemVariants: {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  },

  // Standard item variants for horizontal staggered animations
  itemVariantsHorizontal: {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  },

  // Standard scale animation for modals and overlays
  scaleIn: {
    initial: { scale: 0.9, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.9, opacity: 0 },
    transition: { type: 'spring', damping: 25, stiffness: 300 }
  },

  // Standard button hover animation
  buttonHover: {
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 },
    transition: { duration: 0.2 }
  },

  // Standard card hover animation
  cardHover: {
    whileHover: { 
      y: -5,
      transition: { duration: 0.2 }
    }
  }
};

// Viewport configuration for consistent scroll-triggered animations
export const viewportConfig = {
  once: true,
  margin: "-100px"
};
